// Import all of Bootstrap's JS
import * as bootstrap from 'bootstrap'

import "./components/nav_menu_hover";
